export const iconFontAwesomeCampingFireBurner = (
	<i className="fa-solid fa-fire-burner"></i>
);
